// extracted by mini-css-extract-plugin
export default {"container":"col_2x4Ag","menuLabel":"col_men_2k0Xy","filters":"col_fil_1-Fyv"};